import { render } from "./LangueSelect.vue?vue&type=template&id=b22b1518"
import script from "./LangueSelect.vue?vue&type=script&lang=js"
export * from "./LangueSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__